import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@chatterbug/aaron'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'

import NextActivitiesHeader from './subcomponents/NextActivitiesHeader/NextActivitiesHeader'
import NextActivitiesSkeleton from './NextActivitiesSkeleton'
import NextActivitiesContainer from './subcomponents/NextActivitiesContainer/NextActivitiesContainer'

const NextActivities = ({ activityCardList, title, l2Code, isQueueEmpty }) => {
  return activityCardList?.length ? (
    <NextActivitiesSkeleton
      headerSection={<NextActivitiesHeader title={title} />}
      listSection={
        <NextActivitiesContainer
          activityCardList={activityCardList}
          l2Code={l2Code}
          isQueueEmpty={isQueueEmpty}
        />
      }
      buttonSection={
        isQueueEmpty ? (
          <Button type="primaryAdvanced" href={routes.advanced_topics(l2Code)}>
            {t('Discover more topics')}
          </Button>
        ) : null
      }
    />
  ) : null
}

NextActivities.propTypes = {
  activityCardList: PropTypes.arrayOf(
    PropTypes.shape({
      coverImageUrl: PropTypes.string,
      format: PropTypes.string,
      heading: PropTypes.string.isRequired,
      unit: PropTypes.shape({
        name: PropTypes.string,
      }),
      identifier: PropTypes.string,
    })
  ),
  l2Code: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isQueueEmpty: PropTypes.bool,
}

export default NextActivities
